export const HR_FLOW_PATH_PREFIX = '/hr';
